import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { NfDetailsLoad, NfDetailsReset, NfDetailsUpdateStatus } from './nf-details.actions';
import { NfDetailsState } from './nf-details.state';
import { NfVerificationResponse, NfStatusHistoryResponse } from './models/nf-details.model';
import { NfStatus } from './models/nf-status.enum';

@Injectable({ providedIn: 'root' })
export class NfDetailsFacade {
  record$: Observable<NfVerificationResponse | null> = this.store.select(NfDetailsState.getRecord);
  statusHistory$: Observable<NfStatusHistoryResponse[]> = this.store.select(NfDetailsState.getStatusHistory);
  loading$: Observable<boolean> = this.store.select(NfDetailsState.getLoading);
  submitting$: Observable<boolean> = this.store.select(NfDetailsState.getSubmitting);
  actionsDisabled$: Observable<boolean> = this.store.select(NfDetailsState.getActionsDisabled);

  constructor(private store: Store) {}

  load(id: number): void {
    this.store.dispatch(new NfDetailsLoad(id));
  }

  reset(): void {
    this.store.dispatch(new NfDetailsReset());
  }

  updateStatus(id: number, status: NfStatus): void {
    this.store.dispatch(new NfDetailsUpdateStatus(id, status));
  }
}
